export default {
  measuringManager: {
    list: {
      title: "Measuring",
    },
    create: {
      success: "Add measuring success!",
      keyExisted: "Measuring code is existed!",
    },
    edit: {
      success: "Update measuring success!",
    },
    form: {
      key: {
        label: "Code",
        placeholder: "Input measuring code",
        error: "Please input measuring code!",
      },
      name: {
        label: "Name",
        placeholder: "Input measuring name",
        error: "Please input measuring name!",
      },
      unit: {
        label: "Unit",
        placeholder: "Input unit of measuring",
      },
      error: "Error!",
    },
  },
  stationTypeManager: {
    list: {
      title: "Station type",
    },
    create: {
      success: "Add station type success!",
      keyExisted: "Station type code is existed!",
    },
    edit: {
      success: "Update station type success!",
    },
    form: {
      key: {
        label: "Code",
        placeholder: "Input station type code",
        error: "Please input station type code!",
      },
      name: {
        label: "Name",
        placeholder: "Input station type name",
        error: "Please input station type name!",
      },
      icon: {
        label: "Icon",
      },
      auto: {
        label: "Auto",
      },
      error: "Error!",
    },
  },
  stationAutoManager: {
    list: {
      title: "Station auto",
    },
    create: {
      success: "Add station auto success!",
      keyExisted: "Station auto code is existed!",
    },
    edit: {
      success: "Update station auto success!",
    },
    form: {
      key: {
        label: "Code",
        placeholder: "Input station auto code",
        error: "Please input station auto code!",
      },
      name: {
        label: "Name",
        placeholder: "Input station auto name",
        error: "Please input station auto name!",
      },
      stationType: {
        label: "Type",
        placeholder: "Input type",
      },
      address: {
        label: "Address",
        placeholder: "Address",
      },
      long: {
        label: "Longitude",
        placeholder: "Input longitude",
        error: "Please input longitude",
      },
      lat: {
        label: "Latitude",
        placeholder: "Input latitude",
        error: "Please input latitude",
      },
      emails: {
        label: "Emails",
        placeholder: "Input emails",
        error: "Please input emails",
      },
      phones: {
        label: "Phones",
        placeholder: "Input phones",
        error: "Please input phones",
      },
      measuringKey: {
        label: "Measuring code",
        placeholder: "Input measuring code",
        error: "Please input measuring code",
      },
      measuringName: {
        label: "Measuring name",
        placeholder: "Input measuring name",
        error: "Please input measuring name",
      },
      measuringUnit: {
        label: "Unit",
        placeholder: "Input unit",
        error: "Please input unit",
      },
      measuringMinLimit: {
        label: "Min limit",
        placeholder: "Input min limit",
        error: "Please input min limit",
      },
      measuringMaxLimit: {
        label: "Max limit",
        placeholder: "Input max limit",
        error: "Please input max limit",
      },
      options: {
        isAllowWarning: "Allow Warning",
        isAllowRemote: "Allow Remote",
      },
      error: "Error!",
    },
  },
  dataSearchFrom: {
    form: {
      stationType: {
        label: "Station type",
        placeholder: "Select station type",
      },
      stationAuto: {
        label: "Station auto",
        placeholder: "Select station auto",
      },
      fromDate: {
        label: "From",
        placeholder: "Select from date",
      },
      toDate: {
        label: "To",
        placeholder: "Select to date",
      },
      measuringList: {
        label: "Measuring",
        placeholder: "Select measuring",
        require: "choose at least 1 measuring",
      },
      isExceeded: {
        label: "Is exceeded",
      },
      operator: {
        label: "Operator",
      },
      value: {
        label: "Value",
      },
      type: {
        label: "Report type",
      },
      advanced: {
        label: "Advanced",
      },
    },
  },
  avgSearchFrom: {
    form: {
      stationType: {
        label: "Station type",
        placeholder: "Select station type",
      },
      stationAuto: {
        label: "Station auto",
        placeholder: "Select station auto",
      },
      fromDate: {
        label: "From",
        placeholder: "Select from date",
      },
      toDate: {
        label: "To",
        placeholder: "Select to date",
      },
      measuringList: {
        label: "Measuring",
        placeholder: "Select measuring",
      },
      isExceeded: {
        label: "Is exceeded",
      },
      operator: {
        label: "Operator",
      },
      value: {
        label: "Value",
      },
      type: {
        label: "Report type",
      },
      advanced: {
        label: "Advanced",
      },
    },
    list: {
      receivedAt: {
        label: "Received at",
      },
    },
  },
  userSearchFrom: {
    form: {
      userName: {
        label: "Username",
        placeholder: "Username",
      },
      email: {
        label: "Email",
        placeholder: "Email",
      },
      firstName: {
        label: "FirstName",
        placeholder: "FirstName",
      },
      lastName: {
        label: "LastName",
        placeholder: "LastName",
      },
      country: {
        label: "Country",
        placeholder: "Select Country",
      },
      organization: {
        label: "Organization",
        placeholder: "Select Organization",
      },
      phone: {
        label: "Phone",
        placeholder: "Phone",
      },
    },
  },
  userForm: {
    form: {
      userName: {
        label: "Username",
        placeholder: "Username",
      },
      email: {
        label: "Email",
        placeholder: "Email",
      },
      password: {
        label: "Password",
        placeholder: "Password",
      },
      confirmPassword: {
        label: "Confirm Password",
        placeholder: "Confirm Password",
        message: "Please confirm your password!",
      },
      firstName: {
        label: "FirstName",
        placeholder: "FirstName",
      },
      lastName: {
        label: "LastName",
        placeholder: "LastName",
      },
      country: {
        label: "Country",
        placeholder: "Select Country",
      },
      organization: {
        label: "Organization",
        placeholder: "Select Organization",
      },
      phone: {
        label: "Phone",
        placeholder: "Phone",
      },
      isOwner: {
        label: "isOwner",
        placeholder: "isOwner",
      },
      isAdmin: {
        label: "isAdmin",
        placeholder: "isAdmin",
      },
    },
  },
  userManager: {
    list: {
      enableAccount: "Enable Account",
      disableAccount: "Disable Account",
      confirmEnableAccount: "Do You Want To {0} These Accounts?",
      enable: "Enable",
      disable: "Disable",
      deactivate: "Deactivate",
      action: "Action",
      email: "Email",
      country: "Country",
      login: "Login",
      status: "Status",
      roleAssign: "Assign Role",
      createdAt: "Created At",
      setPassword: "Set Password",
    },
  },
  organization: {
    form: {
      organizationType: {
        label: "Gói khách hàng",
      },
      status: {
        label: "Trạng thái",
        placeholder: "Trạng thái",
        active: "Đang hoạt động",
        aboutToExpired: "Sắp hết hạn",
        expired: "Đã hết hạn",
        unlimited: 'Không giới hạn',
      },
      email: {
        label: "Email tổ chức",
        placeholder: "example@gmail.com",
      },
      name: {
        label: "name",
        placeholder: "name",
      },
      address: {
        label: "address",
        placeholder: "address",
      },
      addressAPI: {
        label: "addressAPI",
        placeholder: "addressAPI",
      },
      databaseInfo: {
        name: {
          label: "database name",
          placeholder: "database name",
          message: "string must not contain special characters!!!",
        },
        address: {
          label: "database address",
          placeholder: "database address",
        },
        user: {
          label: "database user",
          placeholder: "database user",
        },
        pwd: {
          label: "database pwd",
          placeholder: "database pwd",
        },
        confirmPassword: {
          label: "database confirmPassword",
          placeholder: "database confirmPassword",
          message: "Please confirm your password!",
        },
        port: {
          label: "database port",
          placeholder: "database port",
        },
      },
      country: {
        label: "Country",
        placeholder: "Select Country",
      },
      organization: {
        label: "Organization",
        placeholder: "Select Organization",
      },
      phone: {
        label: "Phone",
        placeholder: "Phone",
      },
      totalStation: {
        label: "Giới hạn trạm",
        placeholder: "Giới hạn trạm",
        max: "Tối đa 500 trạm",
      },
      totalUser: {
        label: "Giới hạn tài khoản",
        placeholder: "Giới hạn tài khoản",
        max: "Tối đa 500 tài khoản",
      },
      expirationDate: {
        label: "Ngày hết hạn",
        placeholder: "Ngày hết hạn",
      },
      timeline: {
        label: {
          enabled: "Bật tính năng Timeline",
        },
        input: {
          label: {
            key: "API key",
            secret: "Secret key",
            appId: "App ID",
          },
        },
      },
      timeZone: {
        label: "TimeZone",
        placeholder: "Select TimeZone",
      },
      enableShareAPI: "Bật tính năng Share API",
      apiKey: "API key",
      generateApiKey: "Generate API key",
      regenerateApiKey: "Regenerate API key",
    },
    rule: {
      label: "Rule",
      orderby: {
        label: "STT",
        placeholder: "STT",
      },
      menu: {
        label: "Danh sách module",
        placeholder: "Danh sách module",
      },
      action: {
        label: "Chức năng",
        placeholder: "Chức năng",
        package: "Package",
      },

      dashboard: {
        name: "Giám sát hệ thống"
      },
      dashboard_2: {
        name: "Giám sát tổng quan"
      },
      utilityDashboard:{
        name: 'Bảng điều khiển'
      },
      overview: {
        name: "Trang chủ"
      },
      monitoring: {
        name: "Giám sát trực tuyến",
      },
      monitorByList: {
        name: "Giám sát danh sách",
      },
      map: {
        name: "Bản đồ",
      },
      camera: {
        name: "Camera",
      },
      chart: {
        name: "Phân tích dữ liệu",
      },
      dataSearch: {
        name: "Tra cứu dữ liệu",
      },
      avgSearch: {
        name: "Dữ liệu trung bình",
      },
      xuLyDuLieu_config: {
        name: "Xử lý dữ liệu - Cấu hình",
      },
      kiemDuyetDuLieu: {
        name: "Kiểm duyệt dữ liệu",
      },
      periodicalStation: {
        name: "Trạm quan trắc dự báo định kỳ"
      },
      periodicalImportStation: {
        name: "Nhập dữ liệu dự báo định kỳ"
      },
      periodicalSeachData: {
        name: "Tra cứu dữ liệu dự báo định kỳ"
      },
      qaqcConfig: {
        name: "Cấu hình chia sẻ dữ liệu",
      },
      service_config: {
        name: "Cấu hình dịch vụ",
      },
      ftpTransfer: {
        name: "Cấu hình truyền FTP",
      },
      shareAPI: {
        name: "Chia sẻ API",
      },
      billingReport: {
        name: "Báo cáo phí",
      },
      billingConfig: {
        name: "Cấu hình tính phí",
      },
      incidentManagement: {
        name: 'Quản lý sự cố'
      },
      incidentConfigProperties: {
        name: 'Cấu hình thuộc tính sự cố'
      },
      tiLeDuLieuThuDuoc: {
        name: "Tỉ lệ dữ liệu thu được",
      },
      tiLeDuLieu: {
        name: "Tỉ lệ dữ liệu",
      },
      tb24H: {
        name: "Trung bình 24 giờ",
      },
      tb1H: {
        name: "Trung bình 1 giờ",
      },
      tb1HMax: {
        name: "Trung bình 1 giờ Max",
      },
      tb8HMax: {
        name: "Trung bình 8 giờ Max",
      },
      tileDuLieuVuotNguong: {
        name: "Tỉ lệ dữ liệu vượt ngưỡng",
      },
      soLanMatKetNoi: {
        name: "Số lần mất kết nối",
      },
      aqiReport: {
        name: "Báo cáo AQI",
      },
      wqiGio: {
        name: "WQI - giờ",
      },
      wqiNgay: {
        name: "WQI - ngày",
      },
      wqiPeriodic: {
        name: "WQI - Định kỳ",
      },
      tinhTrangDuLieu: {
        name: "Tình trạng dữ liệu",
      },
      reportExceed: {
        name: "Dữ liệu vượt ngưỡng",
      },
      reportFlow: {
        name: "Lưu lượng phát thải",
      },
      aqiMap: {
        name: "Bản đồ AQI",
      },
      wqiMap: {
        name: "Bản đồ WQI",
      },
      configWQI: {name: "Lựa chọn tính AQI và WQI"},
      stationFixPhase: {
        name:"Quản lý báo cáo định kỳ"
      },
      stationFix: {
        name:"Quản lý điểm quan trắc"
      },
      stationFixInput: {
        name: "Dữ liệu quan trắc"
      },
      stationFixData: {
        name: "Tra cứu dữ liệu điểm quan trắc"
      },
      stationFixMap: {
        name: "Bản đồ điểm quan trắc"
      },
      stationAuto: {name: "Trạm quan trắc"},
      cauHinhKetNoi: {
        name: "Cấu hình kết nối",
      },
      cauHinhGuiCanhBao: {
        name: "Cấu hình gửi cảnh báo",
      },
      cauHinhLayMau: {
        name: "Cấu hình lấy mẫu",
      },
      cauHinhTinhToanAQI: {
        name: "Cấu hình tính toán AQI",
      },
      cauHinhTinhToanWQI: {
        name: "Cấu hình tính toán WQI",
      },
      configCalculate: {
        name: "Cấu hình tính toán",
      },
      cauHinhCamera: {
        name: "Cấu hình camera",
      },
      measuring: {name: "Thông số quan trắc"},
      stationType: {name: "Loại trạm"},
      province: {name: "Đơn vị quản lý"},
      qcvn: {name: "Quy chuẩn"},
      role: {name: "Nhóm quyền"},
      user: {name: "Tài khoản"},
      config_color_noti: {
        name: "Cấu hình màu cảnh báo",
      },
      language:{
        name: "Ngôn ngữ",
      },
      xem_Nhat_ky: {
        name: "Nhật ký",
      },
      connectionManagement: {
        name: 'Quản lý kết nối',
      },
      controlInterface: {
        name: 'Giao diện điều khiển',
      },
      mobile_dashboard: {
        name: "Trang chủ Mobile",
      },
      alarm_management: {
        name: "Cài đặt cảnh báo"
      },
      alarm_history: {
        name: "Lịch sử cảnh báo"
      },
      mapMonitor: {
        name: "Bản đồ AQI/WQI"
      },
      ticket: {
        name: "Sự cố"
      },
      dataAnalytic: {
        name: "Phân tích dữ liệu"
      },
      stationPeriodic: {
        name: "Quan trắc định kỳ"
      },
      connection: {
        name: "Kết nối"
      },
      report: {
        name: "Báo cáo"
      },
      /////
      actions: {
        role: "Ủy quyền",
        enableAccount: "Kích hoạt/Vô hiệu hóa tài khoản",
        config: "Cấu hình",
        download: "Tải mẫu nhập liệu",
        import: "Nhập liệu từ file",
        wqi_export: "Xuất dữ liệu",
        pushDuLieu: "Push dữ liệu",
        aqi_export: "Xuất dữ liệu",
        isTransfer: "Cập nhật trạm cho phép truyền",
        updateFTP: "Cập nhật thông tin FTP",
        publicStation: "Cập nhật trạm công bố",
        view: "Xem",
        camera: "Camera",
        control: "Lấy mẫu",
        chart: "Biểu đồ",
        map: "Bản đồ",
        images: "Hình ảnh",
        infoStation: "Thông tin trạm",
        reviewStation: "Đánh giá trạm",
        updateSelectStation: "Cập nhật chọn trạm",
        create: "Thêm mới",
        edit: "Cập nhật",
        delete: "Xóa",
        export: "Xuất dữ liệu",
        setup: "Thiết lập",
        manualapprove: "Kiểm duyệt tùy chọn",
        unapprove: "Hủy kiểm duyệt",
        approve: "Kiểm duyệt",
        restore: "Khôi phục",
        remove: "Loại bỏ dữ liệu",
        statistics_device: "Tổng kết thiết bị",
        statistics_exceeded_avgDay: "Vượt TB ngày",
        vuotNguongTBNgay: "Vượt ngưỡng TB ngày",
        bieuDoAQI: "Biểu đồ AQI",
        bieuDoWQI: "Biểu đồ WQI",
        bieuDoMatKetNoi: "Số lần mất kết nối",
        bieuDoVuotNguong: "Số lần vượt ngưỡng",
        thongKeLoaiTram: "Thống kê loại trạm",
        fTPFloder: "FTP Floder",
        fileMapping: "File Mapping ",
        exceedDailyAvg: 'Vượt ngưỡng trung bình ngày',
        connect: 'Kết nối',
        linkBilling: 'Liên kết iLotusLand for Utility Billing'
      },
    },
    package: {
      label: "Package",
      totalUser: {
        label: "Total Users",
        message: "Please input total users",
      },
      totalStation: {
        label: "Total Stations",
        message: "Please input total station",
      },
      expiredAt: {
        label: "Expire At",
        message: "Please input expire at",
      },
      contractId: {
        label: "Number Contract",
        message: "Please input number contract",
      },
      contractStatus: {
        label: "Contract Status",
        message: "Please input contract status",
      },
      contractSignDate: {
        label: "Contract Signing Date",
        message: "Please input contract signing date",
      },
      contractExpiredDate: {
        label: "Expire Contract",
        message: "Please input expire contract",
      },
      productionDate: {
        label: "Product Delivery Date",
        message: "Please input product delivery date",
      },
      directSeller: {
        label: "Direct Seller",
        message: "Please input direct seller",
      },
      numberOfExpirationDate: {
        label: "Number of expiration dates",
        message: "Please select number of expiration dates",
        fiveDates: "5 dates",
        tenDates: "10 dates",
        fifteenDates: "15 dates",
        twiceDates: "20 dates",
      },
    },
    language: {
      action: 'Làm mới ngôn ngữ'
    }
  },
  languageLocale: {
    list: {
      title: "Language locale",
    },
    form: {
      key: {
        label: "Code",
        placeholder: "Language locale code",
        error: "Please input language locale code!",
      },
      name: {
        label: "Name",
        placeholder: "Input station type name",
        error: "Please input station type name!",
      },
    },
  },
  addon: {
    create: "Create",
    edit: "Edit",
    delete: "Delete",
    save: "Save",
    remove: "Remove",
    restore: "Restore",
    disable: "Disable",
    updateVersion: 'Thông báo cập nhật phiên bản',
    onSave: {
      add: {
        success: "Add success!",
        error: "Add error!",
      },
      update: {
        success: "Cập nhật thành công!",
        error: "Update error",
      },
    },
    onDelete: {
      success: "Delete success!",
      error: "Delete error!",
    },
    onDisable: {
      success: "Disable success!",
      error: "Disable error!",
    },
    onRestore: {
      success: "Restored Successfully",
      error: "Restore Error",
    },
    onRefreshLanguage: {
      success: "Làm mới ngôn ngữ thành công",
      error: 'Lỗi làm mới ngôn ngữ',
    },
    search: "Search",
  },
  error: {
    reachedMaxUsers:
      "Số lượng tài khoản tối đa của tổ chức này là <%=totalUser || 0 %>, bạn không thể  chuyển thêm tài khoản vào tổ chức này.",
  },
}



// WEBPACK FOOTER //
// ./src/languages/vi.js